import { ImageProps } from './base';

export default function PayPal({ width = '64px' }: ImageProps) {
  return (
    <svg
      fill='none'
      height='21'
      style={{ height: 'initial', width }}
      viewBox='0 0 32 21'
      width='32'
      xmlns='http://www.w3.org/2000/svg'
    >
      <title>Mastercard</title>
      <rect fill='#151514' height='21' rx='4' width='32' />
      <path clipRule='evenodd' d='M13.4631 14.8237H18.2539V6.1759H13.4631V14.8237Z' fill='#FF5F00' fillRule='evenodd' />
      <path
        clipRule='evenodd'
        d='M13.7672 10.5003C13.7672 8.74583 14.585 7.18327 15.8584 6.17635C14.927 5.43983 13.752 5.00046 12.4747 5.00046C9.45103 5.00046 6.99994 7.46284 6.99994 10.5003C6.99994 13.5377 9.45103 16.0001 12.4747 16.0001C13.752 16.0001 14.927 15.5607 15.8584 14.8242C14.585 13.8171 13.7672 12.2547 13.7672 10.5003Z'
        fill='#EB001B'
        fillRule='evenodd'
      />
      <path
        clipRule='evenodd'
        d='M24.546 13.9079V13.6944H24.4905L24.4268 13.8412L24.3629 13.6944H24.3074V13.9079H24.3465V13.7468L24.4064 13.8857H24.447L24.5069 13.7465V13.9079H24.546ZM24.1945 13.9079V13.7308H24.2657V13.6947H24.0847V13.7308H24.1558V13.9079H24.1945ZM24.717 10.4998C24.717 13.5372 22.2657 15.9996 19.2422 15.9996C17.9649 15.9996 16.7897 15.5602 15.8585 14.8237C17.1319 13.8168 17.9497 12.2542 17.9497 10.4998C17.9497 8.74552 17.1319 7.18296 15.8585 6.17589C16.7897 5.43937 17.9649 5 19.2422 5C22.2657 5 24.717 7.46239 24.717 10.4998Z'
        fill='#F79E1B'
        fillRule='evenodd'
      />
    </svg>
  );
}
